import { Image as NbImage } from '@fhs-legacy/native-base';

import { addWithConfig } from '../../utils';

export const Image = NbImage;

export default addWithConfig(Image);
